module.exports = __webpack_public_path__ + "img/short-chain.fb95498e.png";